import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { FuseFullscreenModule } from '@fuse/components/fullscreen/fullscreen.module';
// import { NotificationsModule } from 'app/layout/common/notifications/notifications.module';
// import { QuickChatModule } from 'app/layout/common/quick-chat/quick-chat.module';
// import { SearchModule } from 'app/layout/common/search/search.module';
// import { ShortcutsModule } from 'app/layout/common/shortcuts/shortcuts.module';
import { UserModule } from 'app/layout/common/user/user.module';
import { SharedModule } from 'app/shared/shared.module';
import { ClassyLayoutComponent } from 'app/layout/layouts/vertical/classy/classy.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [ClassyLayoutComponent],
    imports: [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        // NotificationsModule,
        // QuickChatModule,
        // SearchModule,
        // ShortcutsModule,
        UserModule,
        SharedModule,
        MatTooltipModule,
    ],
    exports: [ClassyLayoutComponent],
})
export class ClassyLayoutModule {}
